import { defineComponent as o, createBlock as a, openBlock as n, normalizeProps as p, guardReactiveProps as l, withCtx as s, renderSlot as i, createElementVNode as m } from "vue";
import d from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ o({
  name: "ArrowRight",
  __name: "arrow-right",
  props: {
    props: {
      type: Object
    }
  },
  setup(r) {
    return (t, e) => (n(), a(d, p(l(r.props)), {
      default: s(() => [i(t.$slots, "default"), e[0] || (e[0] = m("path", {
        role: "presentation",
        d: "M16.585 13l-3.295 3.295a1 1 0 001.417 1.412l4.98-4.98a.997.997 0 00.025-1.429l-5.005-5.005a1 1 0 00-1.414 1.414L16.586 11H5a1 1 0 000 2h11.585z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
